import {
  FETCH_GOOGLE_FAIL,
  FETCH_GOOGLE_SUCCESS,
  FETCH_GOOGLE_LOGOUT,
} from "../actions/google_auth";

const initialState = {
  isSignedIn: localStorage.getItem("isSignedIn")
    ? localStorage.getItem("isSignedIn")
    : false,
  loading: false,
  userData: localStorage.getItem("userData")
    ? localStorage.getItem("userData")
    : {},
  error: null,
};

const google_auth = (state = initialState, action) => {
  if (action.type === FETCH_GOOGLE_SUCCESS) {
    localStorage.setItem("isSignedIn", true);
    localStorage.setItem("userData", JSON.stringify(action.data));
    return {
      ...state,
      loading: false,
      isSignedIn: true,
      userData: action.data,
    };
  }
  if (action.type === FETCH_GOOGLE_FAIL) {
    localStorage.clear();
    return {
      ...state,
      loading: false,
      error: action.error,
    };
  }
  if (action.type === FETCH_GOOGLE_LOGOUT) {
    localStorage.clear();
    return {
      ...state,
      loading: false,
      isSignedIn: false,
      userData: null,
      error: null,
    };
  }
  return state;
};

export default google_auth;
